import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CustomFacade } from '@piqet-angular/data';
import {
  CustomModalService,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { noWhitespaceValidator, setDelayedFlag } from 'libs/shared/src/lib/service/helper.service';
import { TitleCasePipe } from '@angular/common';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { CookieService } from 'ngx-cookie-service';
import { ColDef } from 'ag-grid-community';
import { WasteDataGridService } from '@piqet-angular/features';

@Component({
  selector: 'piqet-angular-new-waste-scenario',
  templateUrl: './new-waste-scenario.component.html',
  styleUrls: ['./new-waste-scenario.component.scss'],
  providers: [TitleCasePipe],
})
export class NewWasteScenarioComponent implements OnDestroy, OnInit {
  customWasteScenarioForm!: FormGroup;
  wasteScenarioProcessForm!: FormGroup;
  submitted = false;
  processSubmitted = false;
  isReadonly = true;
  processColumnDef: any;
  modalLabel: any;
  customData: any;
  params: any;
  @Output() saveCustomWasteScenarioEvent = new EventEmitter<{ payload: any; pathName: any }>();
  editDataList: any;

  isHovered = false;
  energyItems: any;
  locationList: any;
  customWasteScenarioId = 0;
  ingredientId: any;
  wasteScenarioTypeId: any;
  ingredientIndex: any;
  mustGreaterValue = false;
  activatedRoute: any;
  selectOrganization: any;
  organizationlist: any;
  isHideDropDown!: boolean;
  gridLoaded = { value: false };
  isDisabledDropDown!: boolean;
  wasteScenatioInputFieldDefaultValue: any;
  endOfLifeIdentifiers: any[] = [];
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
  };
  tableData: any;
  wasteScenarioDataList: any;
  mapWasteScenarioList: any = [];
  selectedDropDownValue: any;
  setOrganizationValue: any;
  fromEdit: any;
  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public customFacade: CustomFacade,
    private customService: CustomService,
    private modal: CustomModalService,
    private wasteScenarioGrid: WasteDataGridService,
    private swalService: SwalService,
    private cookieService: CookieService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.customData =
      this.modal?.modalService?.config?.initialState?.['newCustomWasteScenarioData'];
    this.fromEdit = this.modal?.modalService?.config?.initialState?.['fromEdit'];
    this.isDisabledDropDown = this.modalLabel == 'Review custom waste scenario' ? true : false;
    this.isHideDropDown = this.activatedRoute == 'adminWasteScenarios' ? true : false;
    this.endOfLifeIdentifiers = this.customData?.endOfLifeIdentifierList;
    this.initializeForm();
  }

  ngOnInit(): void {
    this.processColumnDef = this.getNewProcessColumns();
    this.showEdit = this.wasteScenarioGrid.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.wasteScenarioGrid.isAccess(this.activatedRoute, 'create');
    this.showView = this.wasteScenarioGrid.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
    this.initializeData();
  }

  innedGridActionAccess(fromEdit: boolean): boolean {
    return (
      (!fromEdit && this.wasteScenarioGrid.isAccess(this.activatedRoute, 'create')) ||
      (fromEdit && !this.wasteScenarioGrid.isAccess(this.activatedRoute, 'view')) ||
      (fromEdit && this.wasteScenarioGrid.isAccess(this.activatedRoute, 'edit'))
    );
  }

  getNewProcessColumns(): ColDef[] {
    const colDef: ColDef[] = [];

    // Default column for "Material"
    colDef.push({
      ...defaultColumn,
      colId: 'Material',
      headerName: 'Material',
      field: 'material',
      cellClass: 'my-permission-cursor-pointer',
      maxWidth: 112,
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    const parsedWasteScenarios = this.endOfLifeIdentifiers;

    // Generate Columns Dynamically
    parsedWasteScenarios.forEach(scenario => {
      colDef.push({
        ...defaultColumn,
        colId: scenario.name.replace(/\s+/g, ''),
        headerName: scenario.name,
        field: scenario.id.toString(),
        cellClass: 'my-permission-cursor-pointer wasteScenarioClass',
        wrapText: true,
        autoHeight: true,
        lockVisible: true,
        lockPosition: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        resizable: false,
        editable: false,
        sortable: false,
      });
    });

    // Actions Column
    this.innedGridActionAccess(this.fromEdit) &&
      colDef.push({
        ...defaultColumn,
        colId: 'actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer wasteScenarioClass',
        cellRenderer: 'actionRenderer',
        pinned: 'right',
        cellRendererParams: {
          showEdit: true,
          showCopy: true,
          showDelete: true,
          copyData: (data: any) => {
            this.customFacade.copyWasteScenarioDataProcess(data, 'copy');
          },
          editData: (data: any) => {
            this.customFacade.updateWasteScenarioDataProcess(data, 'edit');
          },
          deleteData: (data: any) => {
            this.deleteConfirmation(data);
          },
          copyDataEditRendarar: (data: any) => {
            return false;
          },
        },
        autoHeight: true,
        lockVisible: true,
        lockPosition: true,
        resizable: false,
      });

    return colDef;
  }

  initializeForm() {
    // Initialize the main form
    this.customWasteScenarioForm = this.formBuilder.group({
      wasteScenarioName: ['', [Validators.required, noWhitespaceValidator]],
      location: [null, Validators.required],
      organizationName: [null],
    });

    // Create process form with dynamic controls
    const processFormControls: any = {
      material: [null, Validators.required],
    };

    // Add dynamic controls for each end of life identifier
    this.endOfLifeIdentifiers.forEach(identifier => {
      processFormControls[`eol_${identifier.id}`] = [0, [Validators.required]];
    });
    // Create the process form group
    this.wasteScenarioProcessForm = this.formBuilder.group(processFormControls);

    // Add the process form as a nested form group
    this.customWasteScenarioForm.addControl(
      'wasteScenarioProcessForm',
      this.wasteScenarioProcessForm
    );
    // Update validators based on route
    if (this.isHideDropDown) {
      this.customWasteScenarioForm.controls['organizationName'].setValidators(Validators.required);
    } else {
      this.customWasteScenarioForm.controls['organizationName'].clearValidators();
    }

    this.customWasteScenarioForm.controls['organizationName'].updateValueAndValidity();
  }

  initializeData() {
    if (this.customData) {
      // Patch the main form with initial values
      this.customWasteScenarioForm.patchValue({
        wasteScenarioName: this.customData.name,
        location: this.customData.countryId,
      });

      this.customWasteScenarioId = this.customData.wasteScenarioId;

      // Process waste material list if available
      if (
        this.customData.hasOwnProperty('wasteMaterialList') &&
        this.customData?.wasteMaterialList.length
      ) {
        const gridData: any = [];

        this.customData?.wasteMaterialList?.forEach((element: any) => {
          const data = this.getTableData(element.endOfLifeIdentifierList);

          gridData.push({
            ...data,
            material: element.wasteMaterialName,
            index: element.wasteMaterialId,
            wasteScenarioId: element.wasteScenarioId,
            materialId: element.materialId,
          });
        });

        const indexData = this.customData?.wasteMaterialList.map((data: any) => {
          return {
            ...data,
            index: data.wasteMaterialId,
          };
        });

        this.customFacade.wasteScenarioProcessGrid(gridData, indexData);
      }

      this.locationList = this.customData.locationItems;
      this.energyItems = this.customData.wasteMaterialItems;
      this.organizationlist = this.customData.organizationItems;

      this.organizatioListFunction();
      this.setFormData();
    }

    // Subscribe to process updates
    this.customFacade.copiedWasteScenarioProcess$.subscribe((process: any) => {
      if (process) {
        this.ingredientIndex = process?.index;
        this.ingredientId = process?.id;
        this.wasteScenarioTypeId = process?.materialId;

        // Clear previous values
        this.resetProcessForm();

        // Set material
        this.wasteScenarioProcessForm.get('material')?.setValue(process.material);

        // Set values for each end of life identifier dynamically
        this.endOfLifeIdentifiers.forEach(identifier => {
          this.wasteScenarioProcessForm
            .get(`eol_${identifier.id}`)
            ?.setValue(process[identifier.id.toString()]);
        });
      }
    });

    this.selectedDropDownValue = this.selectOrganization;
    this.setOrganizationValue = this.selectOrganization;

    setDelayedFlag(this.gridLoaded, true, 200);
  }

  async organizatioListFunction() {
    if (this.organizationlist && this.customData.organizationId) {
      const org = this.organizationlist.find(
        (item: any) => item.id === this.customData.organizationId
      );
      if (org) {
        this.selectOrganization = org;
      }
    }
  }

  setFormData() {
    this.customWasteScenarioForm.patchValue({ organizationName: this.selectOrganization });
  }

  onClose() {
    this.modal.close();
    this.customFacade.clearWasteScenarioProcess();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  getDefaultvalue() {
    this.customFacade.addCustomWasteScenarioExistingRecord('');

    if (
      this.wasteScenarioProcessForm.value.material != null &&
      this.wasteScenarioProcessForm.value.material?.description != 'Material' &&
      !!this.customWasteScenarioForm.controls['location']?.value
    ) {
      this.customService
        .getCustomWasteDefaultValues(
          this.customWasteScenarioForm.controls['location']?.value || 0,
          this.wasteScenarioProcessForm.value.material?.id || this.wasteScenarioTypeId
        )
        .subscribe((data: any) => {
          this.wasteScenatioInputFieldDefaultValue = data;
          this.setInputValue();
          if (!this.checkGreaterValue()) {
            this.mustGreaterValue = true;
            return;
          }
        });
    } else {
      this.resetProcessForm();
    }
  }

  resetProcessForm() {
    // Reset all end of life identifier values to 0
    this.endOfLifeIdentifiers.forEach(identifier => {
      this.wasteScenarioProcessForm.get(`eol_${identifier.id}`)?.setValue(0);
    });
  }

  setInputValue() {
    if (this.wasteScenatioInputFieldDefaultValue && this.wasteScenatioInputFieldDefaultValue.data) {
      // For each end of life identifier in the default values, set the corresponding form control value
      this.wasteScenatioInputFieldDefaultValue.data.forEach((item: any) => {
        this.wasteScenarioProcessForm.get(`eol_${item.id}`)?.setValue(item.defaultValue);
      });
    }
  }

  checkGreaterValueMustGreaterValue() {
    if (!this.checkGreaterValue()) {
      this.mustGreaterValue = true;
    } else {
      this.mustGreaterValue = false;
    }
  }

  checkGreaterValue() {
    // Calculate the sum of all end of life identifier values
    let total = 0;
    this.endOfLifeIdentifiers.forEach(identifier => {
      const value = Number(this.wasteScenarioProcessForm.get(`eol_${identifier.id}`)?.value || 0);
      total += value;
    });

    // Check if the sum is between 99.5 and 100
    return total <= 100 && total >= 99.5;
  }

  commonInputSearchForMaterial(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  changeImageOnHover(isHovered: boolean): void {
    this.isHovered = isHovered;
  }

  getTableData(endOfLifeIdentifierList: any) {
    this.tableData = endOfLifeIdentifierList;
    const res: any = this.tableData.map(({ defaultValue, id }: { defaultValue: any; id: any }) => {
      return { defaultValue, id };
    });
    const columnData: any = res.map(({ id, defaultValue }: { id: any; defaultValue: any }) => {
      return { [id]: defaultValue };
    });
    this.wasteScenarioDataList = columnData;

    const list: any = Object.assign({}, ...this.wasteScenarioDataList);
    return list;
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.customFacade.deleteWasteScenarioDataProcess(data, 'delete');
      }
    });
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.',
        'organization'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }

  selectValue(event: any) {
    if (event.name) {
      this.alertConfirmation(event);
    }
  }

  addWasteScanarioProcess(wasteScenarioData: any) {
    this.processSubmitted = true;

    if (
      !this.customWasteScenarioForm.controls['wasteScenarioName'].valid ||
      !this.customWasteScenarioForm.controls['location'].valid
    ) {
      this.submitted = true;
      return;
    }

    if (!this.checkGreaterValue()) {
      this.mustGreaterValue = true;
      return;
    }

    if (
      this.wasteScenarioProcessForm.value.material.description == 'Material' &&
      this.wasteScenarioProcessForm.controls['material'].valid
    ) {
      this.wasteScenarioProcessForm.get('material')?.reset();
      this.processSubmitted = true;
      this.wasteScenarioProcessForm.controls['material'].markAsTouched();
      return;
    }

    if (this.wasteScenarioProcessForm.valid) {
      const existRecord = wasteScenarioData.filter(
        (x: any) => x.materialId == this.wasteScenarioProcessForm.controls['material'].value.id
      );

      if (existRecord.length > 0) {
        this.customFacade.addCustomWasteScenarioExistingRecord('Material is already exist.');
        return;
      }

      // Create end of life identifier list from form values
      const endOfLifeIdentifierList = this.endOfLifeIdentifiers.map(identifier => {
        return {
          id: identifier.id,
          defaultValue: this.wasteScenarioProcessForm.get(`eol_${identifier.id}`)?.value,
        };
      });

      const data = {
        wasteScenarioId: this.customWasteScenarioId,
        materialId: this.wasteScenarioProcessForm.value.material.id || this.wasteScenarioTypeId,
        id: 0,
        wasteMaterialName:
          this.wasteScenarioProcessForm.value.material.description ||
          this.wasteScenarioProcessForm.value.material,
        endOfLifeIdentifierList: endOfLifeIdentifierList,
      };

      this.processSubmitted = false;
      this.mustGreaterValue = false;

      let wasteGridData = this.getTableData(data.endOfLifeIdentifierList);
      wasteGridData = {
        ...wasteGridData,
        material:
          this.wasteScenarioProcessForm.value.material.description ||
          this.wasteScenarioProcessForm.value.material,
        wasteScenarioId: this.customWasteScenarioId,
        materialId: this.wasteScenarioProcessForm.value.material.id || this.wasteScenarioTypeId,
        id: 0,
      };

      this.customFacade.addWasteScenarioDataProcess(data, 'add', null, wasteGridData);
    }
  }

  editWasteScanarioProcess(wasteScenarioData: any) {
    this.processSubmitted = true;

    if (
      !this.customWasteScenarioForm.controls['wasteScenarioName'].valid ||
      !this.customWasteScenarioForm.controls['location'].valid
    ) {
      this.submitted = true;
      return;
    }

    if (!this.checkGreaterValue()) {
      this.mustGreaterValue = true;
      return;
    }

    if (
      this.wasteScenarioProcessForm.value.material.description == 'Material' &&
      this.wasteScenarioProcessForm.controls['material'].valid
    ) {
      this.wasteScenarioProcessForm.get('material')?.reset();
      this.processSubmitted = true;
      this.wasteScenarioProcessForm.controls['material'].markAsTouched();
      return;
    }

    if (this.wasteScenarioProcessForm.valid) {
      // Create end of life identifier list from form values
      const endOfLifeIdentifierList = this.endOfLifeIdentifiers.map(identifier => {
        return {
          id: identifier.id,
          defaultValue: this.wasteScenarioProcessForm.get(`eol_${identifier.id}`)?.value,
        };
      });

      const data = {
        wasteScenarioId: this.customWasteScenarioId,
        materialId: this.wasteScenarioProcessForm.value.material.id || this.wasteScenarioTypeId,
        id: 0,
        wasteMaterialName:
          this.wasteScenarioProcessForm.value.material.description ||
          this.wasteScenarioProcessForm.value.material,
        endOfLifeIdentifierList: endOfLifeIdentifierList,
      };

      let wasteGridData = this.getTableData(data.endOfLifeIdentifierList);
      wasteGridData = {
        ...wasteGridData,
        material:
          this.wasteScenarioProcessForm.value.material.description ||
          this.wasteScenarioProcessForm.value.material,
        wasteScenarioId: this.customWasteScenarioId,
        materialId: this.wasteScenarioProcessForm.value.material.id || this.wasteScenarioTypeId,
        id: 0,
      };

      this.processSubmitted = false;
      this.mustGreaterValue = false;

      this.customFacade.updateWasteScenarioDataProcess(
        data,
        'editIngredient',
        this.ingredientIndex,
        wasteGridData
      );

      this.wasteScenarioProcessForm.reset();
    }
  }

  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Disallow decimal (.) and minus (-)
    if (charCode === 46 || charCode === 45) {
      return false;
    }

    // Allow only numbers (0-9)
    return charCode >= 48 && charCode <= 57;
  }

  validatePaste(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent default paste action

    const pastedText = event.clipboardData?.getData('text') || '';

    // Allow pasting only if it contains only digits (no decimals or negative signs)
    if (/^\d+$/.test(pastedText)) {
      const inputElement = event.target as HTMLInputElement;
      inputElement.value = pastedText; // Manually set the value
      inputElement.dispatchEvent(new Event('input')); // Trigger Angular change detection
    }
  }

  onSave(wasteScenarioProcessList: any) {
    this.submitted = true;
    this.processSubmitted = false;

    if (
      this.activatedRoute == 'adminWasteScenarios' &&
      !this.customWasteScenarioForm.controls['organizationName'].value?.name &&
      !this.customWasteScenarioForm.controls['organizationName'].value
    ) {
      return;
    }

    if (
      this.customWasteScenarioForm.errors == null &&
      this.customWasteScenarioForm.controls['wasteScenarioName'].valid &&
      this.customWasteScenarioForm.controls['location'].valid
    ) {
      const saveCustomWasteScenarioData: any = {
        wasteScenarioId: this.customWasteScenarioId,
        countryId:
          this.customWasteScenarioForm.value.location ||
          this.customWasteScenarioForm.value.location.id,
        name: this.customWasteScenarioForm.value.wasteScenarioName.trimStart(),
        organizationId:
          this.customWasteScenarioForm.controls['organizationName'].value?.id ||
          this.customData.organizationId ||
          Number(this.cookieService.get('organizationId')),
        wasteMaterialList: wasteScenarioProcessList,
      };

      this.saveCustomWasteScenarioEvent.emit({
        payload: saveCustomWasteScenarioData,
        pathName: this.activatedRoute,
      });

      this.submitted = false;
    }
  }

  ngOnDestroy() {
    this.customFacade.clearWasteScenarioRowDataProcess();
  }

  // Helper method to get a form control by end of life identifier id
  getEolControl(id: number) {
    return this.wasteScenarioProcessForm.get(`eol_${id}`);
  }
}
